import React from 'react';
import { Modal } from './Modal';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  return <Modal isOpen={isOpen} onClose={onClose} title="Términos y Condiciones" data-id="element-183">
      <div className="space-y-4" data-id="element-184">
        <section data-id="element-185">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-186">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-187">
            Al adquirir "Conexión Instantánea", aceptas estos términos y
            condiciones en su totalidad. Si no estás de acuerdo con alguna parte
            de estos términos, no debes realizar la compra.
          </p>
        </section>

        <section data-id="element-188">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-189">
            2. Descripción del Producto
          </h3>
          <p data-id="element-190">
            "Conexión Instantánea" es un producto digital que incluye una guía
            en formato PDF con 5 mensajes diseñados para mejorar la comunicación
            en relaciones de pareja. El producto se entrega de forma digital e
            inmediata tras la compra.
          </p>
        </section>

        <section data-id="element-191">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-192">
            3. Uso Personal y No Comercial
          </h3>
          <p data-id="element-193">
            Este producto es para uso personal exclusivamente. No está
            permitido:
          </p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-zinc-400" data-id="element-194">
            <li data-id="element-195">Redistribuir, revender o compartir el contenido</li>
            <li data-id="element-196">Publicar el contenido en sitios web o redes sociales</li>
            <li data-id="element-197">Utilizar el contenido con fines comerciales</li>
            <li data-id="element-198">Modificar o crear obras derivadas del contenido</li>
          </ul>
        </section>

        <section data-id="element-199">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-200">
            4. Acceso y Entrega
          </h3>
          <p data-id="element-201">
            El acceso al producto es inmediato tras completar la compra.
            Recibirás un enlace de descarga por correo electrónico. El acceso es
            de por vida, pero nos reservamos el derecho de actualizar o
            modificar el contenido sin previo aviso.
          </p>
        </section>

        <section data-id="element-202">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-203">
            5. Propiedad Intelectual
          </h3>
          <p data-id="element-204">
            Todo el contenido de "Conexión Instantánea", incluyendo textos,
            diseños y materiales, está protegido por derechos de autor. La
            compra te otorga una licencia de uso personal, no la propiedad del
            contenido.
          </p>
        </section>

        <section data-id="element-205">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-206">
            6. Limitación de Responsabilidad
          </h3>
          <p data-id="element-207">
            Este producto ofrece orientación general y no sustituye terapia
            profesional. No garantizamos resultados específicos. El uso del
            contenido es bajo tu propia responsabilidad. No nos hacemos
            responsables de decisiones tomadas basándose en el contenido.
          </p>
        </section>

        <section data-id="element-208">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-209">7. Modificaciones</h3>
          <p data-id="element-210">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente tras su
            publicación.
          </p>
        </section>

        <section data-id="element-211">
          <h3 className="text-[#d4a574] font-medium mb-2" data-id="element-212">8. Contacto</h3>
          <p data-id="element-213">
            Para cualquier consulta sobre estos términos, puedes contactarnos a
            través de nuestro correo electrónico de soporte.
          </p>
        </section>
      </div>
    </Modal>;
}